import { Card, CardBody, CardHeader } from 'reactstrap'
import CreateJobInput from '../CreateJob/CreateJobInput'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { trackApplication } from 'store/Recruitment/actions'
import { setFormSubmitted } from 'store/Recruitment/actions'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector } from 'react-redux'
import { SET_TRACKING_RESULT } from 'store/Recruitment/types'

import './style.css'

function TrackApplication() {
  const { trackingResult } = useSelector((store) => store.recruitment)
  const history = useHistory()

  const dispatch = useDispatch()
  const [trackingId, setTrackingId] = useState('')
  const [email, setEmail] = useState('')

  useEffect(() => {
    return () => {
      dispatch(setFormSubmitted(false))
      dispatch({ type: SET_TRACKING_RESULT, payload: null })
    }
  }, [dispatch])

  useEffect(() => {
    if (trackingResult && trackingResult.id) {
      history.push(`/job/career?tracking_id=${trackingId}&email=${email}`)
    }
  }, [trackingResult, trackingId, email, history])

  return (
    <Card className='track-application-container mx-auto'>
      <CardHeader className='title'>
        <h1>Track Your Application</h1>
      </CardHeader>
      <CardBody>
        {trackingResult && trackingResult.error && (
          <div className='alert alert-danger' role='alert'>
            {trackingResult.error}
          </div>
        )}

        <CreateJobInput
          id='trackingId'
          label='Tracking Id'
          placeholder='Enter Tracking Id'
          required={true}
          fullSize={true}
          defaultValue={trackingId}
          onChange={(val) => setTrackingId(val)}
        />
        <CreateJobInput
          id='email'
          label='Email'
          placeholder='Enter Email'
          fullSize={true}
          required={true}
          defaultValue={email}
          onChange={(val) => setEmail(val)}
        />
        <button
          onClick={() => {
            dispatch(setFormSubmitted(true))

            const isValid = trackingId && email

            if (!isValid) return

            dispatch(trackApplication({ tracking_id: trackingId, email }))
          }}
          className='btn btn-info w-100'
        >
          Search
        </button>
      </CardBody>
    </Card>
  )
}

export default TrackApplication
